import {EventContainerListDispositionSidePanel} from "~/components/eventContainerDetails/eventContainerListDispositionSidePanel";
import {
    EMOTORAD__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID,
    EMOTORAD_DEFAULT_EVENT_CONTAINER_TRIGGER_CONFIG,
    emotoradDispositionConfig,
} from "~/domainModels/workspaceSpecific/emotorad";
import type {EventContainerTemplate} from "~/domainModels/workspaceModules/eventContainersModule";
import type {EventWithEventContainer} from "~/utilities/apis/api";

/** Emotorad journey dispositions use up to three underscore-separated segments (L1 / L2 / L3). */
const EMOTORAD_DISPOSITION_UI_LEVELS = 3;

function getEmotoradLeadDisplayName(event: EventWithEventContainer): string {
    const raw = event.eventContainer.additionalColumnValues[EMOTORAD__EVENT_CONTAINER__CUSTOMER_NAME__COLUMN_ID];
    if (typeof raw === "string" && raw.trim() !== "") {
        return raw.trim();
    }
    return "Lead";
}

export function EmotoradLeadDispositionModal(props: {
    onClose: () => void;
    event: EventWithEventContainer;
    eventContainerTemplate: EventContainerTemplate;
    queryKeyPrefix: Array<string | null>;
}) {
    const {onClose, event, eventContainerTemplate, queryKeyPrefix} = props;

    return (
        <EventContainerListDispositionSidePanel
            onClose={onClose}
            event={event}
            eventContainerTemplate={eventContainerTemplate}
            // triggerConfiguration={eventContainerTemplate.triggerConfig ?? EMOTORAD_DEFAULT_EVENT_CONTAINER_TRIGGER_CONFIG}
            triggerConfiguration={EMOTORAD_DEFAULT_EVENT_CONTAINER_TRIGGER_CONFIG}
            dispositionConfiguration={emotoradDispositionConfig}
            dispositionUiLevels={EMOTORAD_DISPOSITION_UI_LEVELS}
            getLeadDisplayName={getEmotoradLeadDisplayName}
            queryKeyPrefix={queryKeyPrefix}
        />
    );
}
